module.exports = __webpack_public_path__ + "static/img/card_3_2.c7704de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/card_3_2.png
// module id = bS7f
// module chunks = 0